module.exports = __webpack_public_path__ + "img/sled.f7d2206a.png";